// Shared checkout starter. Lives in its own module so it can be imported by
// both UpgradeModal and CheckoutResumePage without a cycle.

import { toast } from 'sonner';
import { createCheckoutSession } from '@/lib/api';

/**
 * Fires a backend POST that returns a Stripe Checkout Session URL, then
 * redirects the browser. Caller is responsible for ensuring the user is
 * authenticated (otherwise the API will respond 401).
 *
 * @param {string} priceId - "monthly" / "annual" / a Stripe price id
 * @returns {Promise<boolean>} - true if redirecting, false if it failed
 */
export async function startCheckout(priceId) {
  try {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const { data } = await createCheckoutSession(priceId, origin);
    if (data && data.url) {
      window.location.href = data.url;
      return true;
    }
    toast.error('Could not start checkout. Please try again.');
    return false;
  } catch (err) {
    const detail = err?.response?.data?.detail || err?.message || 'Checkout failed';
    toast.error(detail);
    return false;
  }
}
